import { render, staticRenderFns } from "./Labelling.vue?vue&type=template&id=dd83fd1c&scoped=true"
import script from "./Labelling.vue?vue&type=script&lang=js"
export * from "./Labelling.vue?vue&type=script&lang=js"
import style0 from "./Labelling.vue?vue&type=style&index=0&id=dd83fd1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd83fd1c",
  null
  
)

export default component.exports